/* eslint-disable no-underscore-dangle */
import window from 'global';
import { flatMap, chain } from 'lodash';
import logger from './logger';
import { setChildProperty } from './object';

export const formatString = (string) => (string ? string.replace(/[ :]+/g, '-').toLowerCase() : string);

export const getSessionAnalyticsValues = (key) => {
  if (window.sessionStorage) {
    return JSON.parse(window.sessionStorage.getItem(key)) || [];
  }
  return [];
};

export const sessionAnalyticsHasValue = ({ key, value }) => (getSessionAnalyticsValues(key).includes(value));

export const addSessionAnalyticsValue = ({ key, value }) => {
  if (window.sessionStorage) {
    const currentVals = JSON.parse(window.sessionStorage.getItem(key)) || [];
    if (!currentVals.includes(value)) {
      window.sessionStorage.setItem(key, JSON.stringify([...currentVals, value]));
    }
  }
};

export const pageViewEvent = () => {
  window.__analyticsChangeContext = window.__analyticsChangeContext || [];
  window.__analyticsChangeContext.push({
    event: { eventType: 'page_view' },
  });
};

export const pushEvent = ({ event }) => {
  window.__analyticsChangeContext = window.__analyticsChangeContext || [];
  logger.info('Logged analytics event: ', JSON.stringify(event));
  window.__analyticsChangeContext.push(event);
};

export const triggerGenericPageView = ({
  pageName, eventName,
}) => {
  if (pageName) {
    setChildProperty(`adsk:en:partner-finder:${pageName}`, 'digitalData.page.pageName', window);
  }
  const event = {
    eventData: {
      eventName: eventName || 'new_page_view',
    },
  };

  if (!eventName) { // tutorial/cuatedTutorial/curatedList page-view
    event.eventData.values = {
      pageName: window.digitalData.page.pageName,
    };
  }

  pushEvent({ event });
};

export const searchResultLinkClick = (data) => {
  window.__analyticsChangeContext = window.__analyticsChangeContext || [];
  window.__analyticsChangeContext.push({
    eventData: {
      eventName: 'search-results-link',
      values: {
        searchTerm: data?.search || '',
      },
    },
    link: {
      linkSection: 'srp_cards',
      linkTitle: data?.name,
    },
  });
};

const generateFilterData = (data) => flatMap(data, (dataValue, filterCategory) => chain(dataValue)
  .filter('value')
  .map((item) => ({ filterCategory, filterName: item.value }))
  .value());

export const searchResultAnalytics = ({ search, currentPayload, isSearch = true }) => {
  const activeFilters = generateFilterData(search);
  const analyticsData = {
    eventData: {
      eventName: isSearch ? 'internal_search' : 'search_refinement',
      values: {
        searchTerm: search.search || '',
        searchType: 'srp_search',
        searchResultsCount: currentPayload?.pagination?.total_count,
        searchResultsPage: currentPayload?.pagination?.total_pages,
      },
    },
  };
  if (activeFilters?.length) {
    analyticsData.eventData.values.activeFilters = activeFilters;
  }
  window.__analyticsChangeContext = window.__analyticsChangeContext || [];
  window.__analyticsChangeContext.push(analyticsData);
};
